<template>
  <BModalForm
    ref="modal"
    v-bind="$attrs"
    :data="criteria"
    :create-default-data="createDefaultData"
    :action-save="onSave"
    :action-delete="onDelete"
    max-width="600px"
    @closed="$emit('closed')"
  >
    <template #title-text="{ viewOnly, form }">
      {{ getTitle(viewOnly, form) }}
    </template>

    <template #default="{ form, viewOnly }">
      <BTextField
        v-model="form.display_name"
        :readonly="viewOnly"
        label="Наименование отображения"
      />

      <BTextField
        v-model="form.report_name"
        :readonly="viewOnly"
        label="Наименование для отчета"
        class="mt-2"
      />

      <BaseEventParameterList v-if="viewOnly" :criterion-id="form.id" />
    </template>
  </BModalForm>
</template>

<script>
import { RoadmapBaseEventCriteriaModel as Model } from './Model'
import { RoadmapExpertsCriteriaApi } from '@/api/resources/Admin/Roadmap/Experts/Criteria'

import BTextField from '@/components/forms/BTextField.vue'
import BModalForm from '@/components/modals/BModalForm.vue'
import BaseEventParameterList from '../BaseEventParameters/BaseEventParameterList.vue'

export const createDefaultData = () => ({
  display_name: '',
  report_name: '',
})

export default {
  name: 'RoadmapBaseEventsModal',
  components: {
    BModalForm,
    BTextField,
    BaseEventParameterList,
  },
  inheritAttrs: false,
  props: {
    eventId: {
      type: [Number, String],
      required: true,
    },
    criteria: Object,
  },
  data: () => ({
    createDefaultData,
  }),
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close() {
      return this.$refs.modal.close()
    },
    async onDelete(body) {
      const api = new RoadmapExpertsCriteriaApi()
      await api.delete(body.id)
      this.$emit('created')
    },
    async onSave(body) {
      const api = new RoadmapExpertsCriteriaApi()
      if (body.id) {
        await api.update(body.id, {
          ...body,
          base_event_id: this.eventId,
        })
      } else {
        await api.create({
          ...body,
          base_event_id: this.eventId,
        })
      }
      this.$emit('created')
    },
    getTitle(viewOnly, form) {
      if (viewOnly) return Model.page_title.view(form)
      return form.id ? Model.page_title.edit : Model.page_title.create
    },
  },
}
</script>
